// @flow
import React, { Component } from 'react'
import styled from 'styled-components'
import type { Node } from 'react'
import Tooltip from '../Tooltip'

const PopupText = styled.div`
  margin-bottom: 7px;

  &:last-of-type {
    margin-bottom: 0;
  }
`
const Trigger = styled.div`
  cursor: help;
  text-decoration: none;
  ${({ dashed }: Object) =>
    dashed &&
    `
    font-size: 12px;
    color: #2099ca;
    border-bottom: #2099ca 1px dashed;
    display: inline;
 `};
`

const Popup = styled.div`
  width: 310px;
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  line-height: 1.4;
  font-weight: bold;
  text-align: left;

  a {
    color: #2099ca;
  }
`

type Props = {|
  triggerText?: string,
  popupText?: string,
  className?: string,
  triggerClassName?: string,
  popupRenderer?: any,
  dashed?: boolean,
  children?: Node,
  alignLeft?: boolean,
  isInteractive?: boolean
|}

export default class HintWrapper extends Component<Props> {
  leaveInterval: any

  renderPopupText(): Array<Node> | string {
    const { popupText } = this.props

    if (!popupText) return ''
    const textList = popupText.split('\n')

    if (textList.length <= 1) return popupText

    return textList.map((text, index) => <PopupText key={index}>{text}</PopupText>)
  }

  render() {
    const { children, triggerText, popupRenderer, dashed, triggerClassName, alignLeft } = this.props

    return (
      <Tooltip
        isInteractive={this.props.isInteractive}
        className={this.props.className}
        position={alignLeft ? 'bottom-start' : 'bottom'}
        content={<Popup alignLeft={alignLeft}>{popupRenderer || this.renderPopupText()}</Popup>}
      >
        <Trigger dashed={dashed} className={triggerClassName}>
          {children || triggerText}
        </Trigger>
      </Tooltip>
    )
  }
}
